import { resolveCountry, separatorsByCountry } from "./FormatByCountry";

const replaceComma = (value: string) => {
  const { thousand } = separatorsByCountry(resolveCountry());
  return value?.toString().split(thousand).join("");
};
export default replaceComma;
